
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ATTR_UNITOFMEASURE } from '../helpers/constants'
import DownloadItem from './download-item.vue'

@Component({
  template: `
    <div>
      <div class="article-section" v-if="properties.foundVariations.length > 0">
        <table class="product-specifications-table product-specifications-table--be">
          <tbody>
            <tr v-if="productTitle">
              <td class="gray3--text">{{ articleNameTitle }}</td>
              <td class="gray4--text">{{ productTitle }}</td>
            </tr>
            <tr v-if="this.variantSku">
              <td class="gray3--text">{{ articleNumberTitle }}</td>
              <td class="gray4--text">{{ this.variantSku }}</td>
            </tr>
            <tr
              v-if="isVariant && groupProperties && groupProperties.length > 0"
              v-for="(value, index) in groupProperties"
            >
              <td class="gray3--text">{{ value.displayName }}</td>
              <td class="gray4--text">{{ propertyValue(value) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  `
})
export default class ProductSpecificationsBe extends Vue {
  @Prop() properties!: any
  @Prop({ default: '' }) productTitle: string
  @Prop() variantSku: any
  @Prop() isVariant: boolean
  @Prop({ default: '' }) articleNameTitle: string
  @Prop({ default: '' }) articleNumberTitle: string
  ignorePropertyNames: string[] = ['ProductFilters', 'ShowVariantTable']

  get groupProperties(): any {
    if (this.properties && this.properties.foundVariations.length > 0) {
      const grouped = this.properties.foundVariations[0].properties
        .filter((obj: any) => obj.value && !this.ignorePropertyNames.includes(obj.name))
        .map((item: any) => {
          return item
        })
      return grouped
    }
    return []
  }

  propertyValue(prop: any): string {
    if (prop.isMultivalue) return prop.values.toString()
    if (prop.valueType == 'Boolean' && (prop.value == 'True' || prop.value == 'False'))
      return this.$options?.filters?.t(`${prop.value.toLowerCase()}Label`)
    const unitValue = prop.attributes.filter((item: any) => item.name === ATTR_UNITOFMEASURE)[0]?.value || ''
    if (unitValue) return prop.value + ' ' + unitValue

    return prop.value
  }
}
